import { isNil, is } from 'ramda';

// Check if value is
// - not null
// - not an array
// - is an object
export const isObject = (obj) => !isNil(obj) && !Array.isArray(obj) && is(Object, obj);
